<template>
  <div class="article-card">
    <div class="card-container">
      <div class="article-image">
        <img :src="articleImage" :alt="article.title" class="article-img" @click.prevent="goToArticle(article)" />
      </div>
      <div class="article-content">
        <h3 class="article-title" @click.prevent="goToArticle(article)">
          {{ article.title }}
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
  import ArticleImgDefault from "@/assets/images/product_default.png";

  export default {
    name: "ArticleCard",
    data() {
      return {
        ArticleImgDefault,
      };
    },
    props: {
      article: {
        type: Object,
        required: true,
      },
    },
    computed: {
      articleImage() {
        if (this.article.image) {
          if (this.article.image.path) {
            return this.article.image.path;
          }
          if (Array.isArray(this.article.image) && this.article.image.length > 0) {
            return this.article.image[0].path || this.article.image[0];
          }
        }
        return this.ArticleImgDefault;
      },
    },
    methods: {
      extractTextFromContent(content) {
        if (!content) return "";
        try {
          const contentArray = JSON.parse(content);
          let text = "";
          contentArray.forEach(block => {
            if (block.data && block.data.content) {
              text += block.data.content + " ";
            }
          });
          return text.length > 100 ? text.slice(0, 100) + "..." : text;
        } catch (error) {
          return "";
        }
      },
      truncateHtmlContent(html) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        const plainText = tempDiv.textContent || tempDiv.innerText || "";
        return plainText.length > 40 ? plainText.slice(0, 40) + "..." : plainText;
      },
      goToArticle(article) {
        var slug = article.id + (article.slug ? "-" + article.slug : "");
        this.$router.push({ name: "pageDetailView", params: { slug } });
      },
    },
  };
</script>

<style scoped>
  .article-card {
    margin-bottom: 20px;
    height: 100%;
  }

  .card-container {
    background: #ffffff;
    border-radius: 10px;
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .article-image {
    position: relative;
    overflow: hidden;
    height: 200px;
  }

  .article-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }

  .article-content {
    padding: 15px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .article-title {
    font-size: 16px;
    font-weight: bold;
    color: #1e347d;
    margin: 0;
    cursor: pointer;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: color 0.3s ease;
  }

  .article-title:hover {
    color: #ec621a;
  }

  @media (max-width: 1200px) {
    .article-image {
      height: 180px;
    }

    .article-title {
      font-size: 15px;
    }
  }

  @media (max-width: 768px) {
    .card-container {
      border-radius: 8px;
    }

    .article-image {
      height: 160px;
    }

    .article-content {
      padding: 12px;
    }

    .article-title {
      font-size: 14px;
    }
  }

  @media (max-width: 480px) {
    .article-image {
      height: 140px;
    }

    .article-content {
      padding: 10px;
    }

    .article-title {
      font-size: 13px;
    }
  }
</style>
